// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Loading_ldsRoller__HsbuV","lds-roller":"Loading_lds-roller__XEuaA"};